// project-imports
import account from './account';
import customers from './customers';
import development from './development';
import developmentCompany from './developmentCompany';
import discoveryTrip from './discoveryTrip';
import marketplace from './marketplace';
import others from './others';
import overview from './overview';
import tools from './tools';
// import documentation from './_documentation';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  // items: [overview, development, tools, account, others]
  items: [overview, development, developmentCompany, customers, tools, discoveryTrip, account, marketplace, others]
};

export default menuItems;
